import { UserInfo } from '@microsoft/teamsfx';

import { logError } from 'src/logging/logError';
import { rootStoreInstance } from 'src/stores/RootStore';
import { ErrorCodes, LogSeverity } from 'src/utils/enums';

type AppErrorConstructorParams = {
  name: string
  message: string
  errorCode: ErrorCodes
  user?: UserInfo | null
  originalError?: unknown
  context?: Record<string, unknown>
};

export class AppError extends Error {
  public errorCode: ErrorCodes;
  public user?: UserInfo | null;
  public originalError?: unknown;
  public context?: Record<string, unknown>;
  public isLogged: boolean = false;

  public isError(error: unknown): error is Error {
    return error instanceof Error;
  }

  constructor({ name, message, errorCode, user, originalError, context }: AppErrorConstructorParams) {
    super(message);
    this.name = name;
    this.errorCode = errorCode;
    this.user = user || rootStoreInstance.teamsUserStore.user;
    this.originalError = originalError;
    this.context = context || {};

    if (originalError instanceof AppError) {
      this.isLogged = originalError.isLogged;
      this.context = { ...(originalError.context || {}), ...this.context };
    }

    if (this.isError(originalError) && originalError?.stack) {
      this.stack = originalError.stack;
    }
    else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }

  logError = (logSeverity = LogSeverity.ERROR): void => {
    // Only log the error if it has not been logged previously
    if (!this.isLogged) {
      logError(this, logSeverity);
      this.isLogged = true;
    }
  };
}
